import * as React from "react";
const SvgITag = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="#BB70D5" viewBox="0 0 16 16" {...props}><circle cx={8} cy={8} r={8} fill="auto" /><path fill="#fff" d="M8.697 12H7.572V3.469h1.125z" /></svg>;
export default SvgITag;